/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeploymentFunctions = {
  /**
   * The ID of the uploaded asset.
   */
  assetId: string;
  /**
   * The ID of the deployment asset.
   */
  id: string;
  /**
   * The memory limit in MiB of function runner machines.
   */
  memoryMib?: number | undefined;
  /**
   * The name to give the document as it will be displayed in UIs.
   */
  name: string;
  /**
   * The runtime to use when executing functions.
   */
  runtime: string;
  /**
   * The number of instances to run for the function.
   */
  scale?: number | undefined;
  /**
   * A short url-friendly label that uniquely identifies a resource.
   */
  slug: string;
};

/** @internal */
export const DeploymentFunctions$inboundSchema: z.ZodMiniType<
  DeploymentFunctions,
  unknown
> = z.pipe(
  z.object({
    asset_id: z.string(),
    id: z.string(),
    memory_mib: z.optional(z.int()),
    name: z.string(),
    runtime: z.string(),
    scale: z.optional(z.int()),
    slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "asset_id": "assetId",
      "memory_mib": "memoryMib",
    });
  }),
);

export function deploymentFunctionsFromJSON(
  jsonString: string,
): SafeParseResult<DeploymentFunctions, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeploymentFunctions$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeploymentFunctions' from JSON`,
  );
}
